import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { SessionExpiredService } from './session-expired.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    public auth: AuthService,
    public router: Router,
    private sessionExpiredService: SessionExpiredService
  ) { }
  
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.auth.isAuthenticated()) {
      if (this.auth.getRefreshToken()) {
        this.sessionExpiredService.show();
      } else {
        this.auth.clearSession();
        void this.router.navigate(['/login']);
      }
      return false;
    }
    return true;
  }

}
